import { useEffect, useRef, useState } from 'react';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry';
import { Label } from 'components/Fields';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

/* 별첨 파일이 PDF인 경우의 미리보기
 *
 * <img>는 PDF를 표시할 수 없고, <iframe>/<embed>는 화면에는 보여도
 * html2canvas(제출 PDF 추출)가 캡처하지 못해 빈 화면이 됩니다.
 * pdf.js로 첫 페이지를 <canvas>에 그리면 화면 표시와 PDF 캡처가 모두 가능합니다.
 */

/** URL이 PDF 파일인지 판별 (쿼리스트링 허용) */
export const isPdfUrl = (url) => /\.pdf(\?|#|$)/i.test(url || '');

const RENDER_SCALE = 2; // 캡처 선명도용 렌더 배율

export default function PdfFilePreview({ url }) {
  const canvasRef = useRef(null);
  const [status, setStatus] = useState('loading'); // 'loading' | 'done' | 'error'

  useEffect(() => {
    if (!url) return;

    let cancelled = false;

    (async () => {
      try {
        const pdf = await pdfjsLib.getDocument({ url }).promise;
        const page = await pdf.getPage(1); // 첫 페이지만 표시

        if (cancelled || !canvasRef.current) return;

        const viewport = page.getViewport({ scale: RENDER_SCALE });
        const canvas = canvasRef.current;
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;

        if (!cancelled) setStatus('done');
      } catch (error) {
        console.error('PDF 미리보기 렌더링 실패 :', error);
        if (!cancelled) setStatus('error');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [url]);

  if (status === 'error') {
    return <Label $needFixedSize={false}>PDF 파일 미리보기를 불러오지 못했습니다</Label>;
  }

  return (
    <canvas
      ref={canvasRef}
      style={{ maxWidth: '100%', maxHeight: '100%', display: status === 'done' ? 'block' : 'none' }}
    />
  );
}
